import {
  Button,
  Grid,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import DateRangeIcon from '@material-ui/icons/DateRange'
import i18n from 'i18next'
import { useState, useEffect } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { formValueSelector, reduxForm, change, Field } from 'redux-form'
import { stepForward } from '../../../actions/apartments'
import ErrorMessage from '../../../components/Error/ErrorMessage'
import {
  ReduxCheckbox,
  ReduxDatePicker,
  ReduxFormField,
  ReduxGoogleAutocomplete
} from '../../../components/FormInput/ReduxWrappers'
// import ErrorMessage from '../../../components/Error/ErrorMessage'
//import customCloseIcon from '../../../images/customCloseIcon.svg'
//import { callOpenAI } from '../../../services/openAI'
import {
  onlyNums,
  onlyNumsAndDecimals,
  charsSpace,
} from '../../../libs/normalize/information'
import tick from '../../../images/tick.svg'
import { MuiClasses } from '../../../types'
import {
  ApartmentInformation,
  BuildingInfo,
  PropertyInfo
} from '../../../types/apartments'
import { AutocompleteOption } from '../../../types/autocomplete'
import { BasicFieldProps, ReduxForm } from '../../../types/forms'
import {
  BalconyOptions,
  BuildingTypeOptions,
  ConditionOptions,
  DishwasherOptions,
  KitchenOptions,
  LaundryMachineOptions,
  RoomOptions,
  WaterFeeBasis,
  WaterFeeBasisOptions
} from '../../../types/propValues/apartments'

import { StateInterface } from '../../../types/states'
import { showWaterFee } from '../../../utils/apartments'
import { energyCertifications } from '../../../utils/validation/energyCertifications'
import {
  required,
  requiredLocation,
  isPostalCode,
  isStreetNumber,
  lessThanAvailableUntil,
  lessOrEqualThanFloors,
  moreOrEqualThanFloor,
  validatePostalArea,
  validateYear,
  isInvalidCharacters,
  isNumericOrEmpty
} from '../../../utils/validation/forms'
import { arrayOfCities } from '../../../utils/validation/listOfCitiesForPostalArea'
//import { useDispatch } from 'react-redux'
//import Dialog from '../../Dialog'
import {
  MyApartmentRadio,
  MyInput,
  MyTextArea,
  ReduxFormSelect
} from '../../NewApplication/Fields'
// import FirstLinkModal from '../Modals/FirstLinkModal'
// import FourLinkModal from '../Modals/FourLinkModal'
// import SecongLinkModal from '../Modals/SecongLinkModal'
// import ThirdLinkModal from '../Modals/ThirdLinkModal'
import { BackButton } from '../Stepper/BackButton'
import NextStepButton from '../Stepper/NextStepButton'
import Suggest from '../Stepper/Steps/Suggest'
import RentRecommendation from './RentRecommendation'
import SubmitButton from '../Stepper/SubmitButton'
import { AdditionalInfoFields } from './InfoFormFields'
import {
  checkboxProperties,
  getValuesAndLabels
} from './values/apartmentProperties'

interface ApartmentInformationFormProps
  extends WithTranslation,
  ReduxForm,
  ApartmentInformation {
  autocompleteLocation: undefined | AutocompleteOption | string
  updateApartmentInformation: (arg: any) => any
  isDisabled: boolean
  classes: MuiClasses
  t: i18n.TFunction
  changeFormValue: (field: string, value: string) => void
  currentStep: any
  doStepBack: () => void
  isMobile: any
  waterFeeBasis: WaterFeeBasis | undefined
  beforeLogin?: boolean
  doNextStep: any
  internetIncluded?: boolean;
  renovatedCheckBoxProperty?: boolean;
  hasElevator?: boolean;
  isFurnished?: boolean;
  hasBuiltInClosetCheckBoxProperty?: boolean;
  hasSaunaCheckBoxProperty?: boolean;
  petsAllowedCheckBoxProperty?: boolean;
  housingPropertySauna?: boolean;
  newProperty?: boolean;
  initialValues: any
}
const CheckBoxProperties = ({ t, isDisabled }: BasicFieldProps) => (
  <>
    <Grid item sm={12}>
      <Typography variant='body1' gutterBottom style={{ marginBottom: '15px' }}>
        {t('apartment.additionalProperties.feature')}
      </Typography>
    </Grid>
    <Grid container spacing={1}>
      {checkboxProperties.map(({ value, label }, index) => (
        // last 2 values are sm={12}, others are sm={4}
        <Grid item xs={6} sm={6} key={value}>
          <Field
            key={value}
            name={value}
            component={ReduxCheckbox}
            disabled={isDisabled}
            custom={true}
            label={t(label)}
          />
        </Grid>
      ))}
    </Grid>
  </>
)
const ApartmentInformationForm = ({
  classes,
  t,
  handleSubmit,
  submitting,
  error,
  updateApartmentInformation,
  isDisabled,
  autocompleteLocation,
  postalArea,
  postalCode,
  squareMeters,
  rooms,
  kitchen,
  buildYear,
  floor,
  floors,
  availableFromDate,
  buildingType,
  condition,
  doStepBack,
  storage,
  balcony,
  parking,
  heating,
  sauna,
  petsAllowed,
  dishwasher,
  laundryMachine,
  changeFormValue,
  waterFeeBasis,
  waterFee,
  currentStep,
  isMobile,
  beforeLogin,
  price,
  notes,
  doNextStep,
  district,
  //apartmentNumber,
  buildingLetter,
  streetNumber,
  damages,
  renovations,
  energyCertification,
  internetIncluded,
  renovatedCheckBoxProperty,
  hasElevator,
  isFurnished,
  hasBuiltInClosetCheckBoxProperty,
  hasSaunaCheckBoxProperty,
  petsAllowedCheckBoxProperty,
  initialValues,
}: ApartmentInformationFormProps) => {
  const getWaterFeeAdornment = (waterFeeBasis: WaterFeeBasis) => {
    const abbreviation =
      waterFeeBasis === 'perTenant' || waterFeeBasis === 'metered'
        ? 'perPersonPerMonth'
        : 'perMonth'
    return `€${i18n.t(`abbreviations.${abbreviation}`)}`
  }
  const [isLoading, setLoading] = useState(false)
  const [isEmpty, setIsEmpty] = useState(false)
  const [aiImprovement, setAiImprovement] = useState(true)
  const [showAiImprovement, setShowAiImprovement] = useState(false)
  const hasSavedInformation =
    Boolean(initialValues?.buildingType) || Boolean(initialValues?.squareMeters)
  const editBanner = hasSavedInformation
  const checkUndefinedProperties = () => {
    const {
      availableFromDate,
      postalArea,
      price,
      waterFee,
      waterFeeBasis,
    } = initialValues;

    return (
      availableFromDate === undefined &&
      postalArea === undefined &&
      price === undefined &&
      waterFee === undefined &&
      waterFeeBasis === undefined
    );
  };

  useEffect(() => {
    if (checkUndefinedProperties()) {
      setShowAiImprovement(true)
    } else {
      setShowAiImprovement(false)
      setAiImprovement(false)
    }
  }, [initialValues]);

  const addressInfoValues = {
    autocompleteLocation,
    postalArea,
    postalCode,
    streetNumber,
    district,
    // apartmentNumber,
    buildingLetter,
    floor,
    floors
  }
  const buildingInfo: BuildingInfo = {
    buildYear,
    buildingType,
    storage
  }
  const propertyInfoValues: PropertyInfo = {
    squareMeters,
    rooms,
    kitchen,
    balcony,
    condition,
    price
  }
  const additionalProps = {
    heating,
    sauna,
    parking,
    petsAllowed,
    dishwasher,
    laundryMachine
  }

  const handleGenerateAIAndProceed = async () => {
    setLoading(true);
    handleSubmit(updateApartmentInformation)();
    setLoading(false);
  }

  const handleNextStep = () => {
    // Save aiImprovement to localStorage if it's true, and remove it if it's false
    if (aiImprovement) {
      localStorage.setItem('aiImprovement', 'true');
    } else {
      localStorage.removeItem('aiImprovement');
    }

    handleGenerateAIAndProceed();
  };

  useEffect(() => {
    localStorage.removeItem('aiImprovement');
  }, []);

  {
    return (
      <form onSubmit={handleSubmit(updateApartmentInformation)}>
        <Grid container>
          {' '}
          <Grid container>
            {' '}
            {currentStep === 0 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      {editBanner ? (
                        <Paper elevation={0} className={classes.editBanner}>
                          <Typography
                            variant='h5'
                            className={classes.editBannerTitle}
                          >
                            {t('apartments.editBanner.title')}
                          </Typography>
                          <Typography
                            variant='body1'
                            className={classes.editBannerText}
                          >
                            {t('apartments.editBanner.description')}
                          </Typography>
                        </Paper>
                      ) : (
                        <List style={{ marginBottom: '40px' }}>
                          <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                            <ListItemIcon>
                              <img src={tick} />
                            </ListItemIcon>
                            <ListItemText primary={t('apartment.tick-0')} />
                          </ListItem>
                          <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                            <ListItemIcon>
                              <img src={tick} />
                            </ListItemIcon>
                            <ListItemText primary={t('apartment.tick-1')} />
                          </ListItem>
                          <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                            <ListItemIcon>
                              <img src={tick} />
                            </ListItemIcon>
                            <ListItemText primary={t('apartment.tick-2')} />
                          </ListItem>
                          <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                            <ListItemIcon>
                              <img src={tick} />
                            </ListItemIcon>
                            <ListItemText primary={t('apartment.tick-3')} />
                          </ListItem>
                          <ListItem style={{ paddingLeft: '0', paddingBottom: '4px' }}>
                            <ListItemIcon>
                              <img src={tick} />
                            </ListItemIcon>
                            <ListItemText primary={t('apartment.tick-4')} />
                          </ListItem>
                        </List>
                      )}
                      <Grid item sm={12}>
                        <Typography
                          variant='h5'
                          className={classes.firstStepHeading}
                          gutterBottom
                        >
                          {t('apartment.steps.step0heading')}
                        </Typography>
                      </Grid>{' '}
                      <Grid item xs={12}>
                        <Field
                          name='buildingType'
                          validate={[required]}
                          component={MyApartmentRadio}
                          required
                          style={{ height: '58px' }}
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            BuildingTypeOptions,
                            'buildingType'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <NextStepButton
                        type='button'
                        beforeLogin={beforeLogin}
                        setIsEmpty={setIsEmpty}
                        toValidate={{
                          buildingType: buildingInfo.buildingType
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest
                        fullWidth
                        content={t('apartment.hints.step0Hint')}
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 1 && (
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step1heading')}
                      </Typography>
                    </Grid>{' '}
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' align='left' gutterBottom>
                        {t('apartment.rooms.label')}
                      </Typography>
                      <Field
                        name='rooms'
                        validate={[required]}
                        component={MyApartmentRadio}
                        required
                        style={{ height: '58px' }}
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          RoomOptions,
                          'rooms'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' align='left' gutterBottom>
                        {t('apartment.kitchen.label')}
                      </Typography>
                      <Field
                        name='kitchen'
                        validate={[required]}
                        component={MyApartmentRadio}
                        required
                        style={{ height: '58px' }}
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          KitchenOptions,
                          'kitchen'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                  </Grid>
                  {isEmpty && (
                    <Typography style={{ color: 'red' }} variant='body1'>
                      {t('apartment.actions.stepFail')}
                    </Typography>
                  )}
                  <Grid container className={classes.buttonContainer}>
                    <Grid item xs={4}>
                      <BackButton
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <NextStepButton
                        type='button'
                        beforeLogin={beforeLogin}
                        setIsEmpty={setIsEmpty}
                        toValidate={{
                          kitchen: propertyInfoValues.kitchen,
                          rooms: propertyInfoValues.rooms
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest
                      fullWidth
                      content={t('apartment.hints.step1Hint')}
                    />
                  </div>
                </Grid>
              </Grid>
            )}
            {currentStep === 2 && (
              <Grid container>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <Grid className={classes.largeForm} container>
                    {' '}
                    <Grid item sm={12}>
                      <Typography variant='h5' gutterBottom>
                        {t('apartment.steps.step2heading')}
                      </Typography>
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' align='left' gutterBottom>
                        {t('apartment.balcony.label')}
                      </Typography>
                      <Field
                        name='balcony'
                        validate={[required]}
                        component={MyApartmentRadio}
                        required
                        style={{ height: '58px' }}
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          BalconyOptions,
                          'balcony'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    <Grid
                      className={classes.containerItem}
                      item
                      xs={12}
                      sm={12}
                    >
                      <Typography variant='body1' align='left' gutterBottom>
                        {t('apartment.condition.label')}
                      </Typography>
                      <Field
                        name='condition'
                        validate={[required]}
                        component={MyApartmentRadio}
                        required
                        style={{ height: '58px' }}
                        disabled={isDisabled}
                        items={getValuesAndLabels(
                          ConditionOptions,
                          'condition'
                        ).map(({ value, label }) => [value, t(label)])}
                      />
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                  </Grid>
                  <Grid container className={classes.buttonContainer}>
                    <Grid item xs={4}>
                      <BackButton
                        currentStep={currentStep}
                        doStepBack={doStepBack}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <NextStepButton
                        beforeLogin={beforeLogin}
                        type='button'
                        setIsEmpty={setIsEmpty}
                        toValidate={{
                          condition: propertyInfoValues.condition,
                          balcony: propertyInfoValues.balcony
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest
                      fullWidth
                      content={t('apartment.hints.step1Hint')}
                    />
                  </div>
                </Grid>
              </Grid>
            )}
            {currentStep === 3 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      {' '}
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step3heading')}
                        </Typography>
                      </Grid>
                      <Grid
                        className={classes.containerItem}
                        item
                        xs={12}
                        sm={12}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.dishwasher.label')}
                        </Typography>
                        <Field
                          name='dishwasher'
                          select
                          component={MyApartmentRadio}
                          required
                          validate={[required]}
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            DishwasherOptions,
                            'dishwasher'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                      <Grid
                        className={classes.containerItem}
                        item
                        xs={12}
                        sm={12}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.laundryMachine.label')}
                        </Typography>
                        <Field
                          name='laundryMachine'
                          select
                          component={MyApartmentRadio}
                          required
                          validate={[required]}
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            LaundryMachineOptions,
                            'laundryMachine'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                      <Grid
                        className={classes.containerItem}
                        item
                        xs={12}
                        sm={12}
                      >
                        <Typography variant='body1' gutterBottom>
                          {t('apartment.waterFeeBasis.label')}
                        </Typography>
                        <ReduxFormField
                          name='waterFeeBasis'
                          select
                          component={MyApartmentRadio}
                          required
                          style={{
                            width: '33%'
                          }}
                          validate={[required]}
                          disabled={isDisabled}
                          items={getValuesAndLabels(
                            WaterFeeBasisOptions,
                            'waterFeeBasis'
                          ).map(({ value, label }) => [value, t(label)])}
                        />
                      </Grid>
                      {waterFeeBasis && showWaterFee(waterFeeBasis) && (
                        <Grid
                          className={classes.containerItem}
                          item
                          xs={4}
                          sm={4}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t(
                              waterFeeBasis === 'metered'
                                ? 'apartment.advanceWaterFee'
                                : 'apartment.waterFee'
                            )}
                          </Typography>
                          <ReduxFormField
                            name='waterFee'
                            type='number'
                            normalize={onlyNumsAndDecimals}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={
                              WaterFeeBasisOptions.metered
                                ? [isInvalidCharacters]
                                : [required, isInvalidCharacters]
                            }
                            required={
                              WaterFeeBasisOptions.metered ? undefined : true
                            }
                            disabled={isDisabled}
                            InputProps={{
                              min: 0,
                              step: 0.01,
                              endAdornment: getWaterFeeAdornment(waterFeeBasis)
                            }}
                            InputIcon='€'
                          />
                        </Grid>
                      )}
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <Grid item xs={4}>
                        <BackButton
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          toValidate={{
                            dishwasher: additionalProps.dishwasher,
                            laundryMachine: additionalProps.laundryMachine,
                            waterFeeBasis: waterFeeBasis
                          }}
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest
                        fullWidth
                        content={t('apartment.hints.step3Hint')}
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 4 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      {' '}
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step4heading')}
                        </Typography>
                      </Grid>
                      <Grid item className={classes.containerItem} xs={12}>
                        <CheckBoxProperties t={t} isDisabled={isDisabled} />
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <Grid item xs={4}>
                        <BackButton
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          // toValidate={{ notes: notes }}
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      {' '}
                      <Suggest
                        fullWidth
                        content={t('apartment.hints.step4Hint')}
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 6 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step5heading')}
                        </Typography>
                      </Grid>{' '}
                      <Grid container spacing={1}>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={12}
                          sm={12}
                        >
                          {' '}
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.availableFromDate')}
                          </Typography>
                          <Grid item xs={12} className={classes.datePicker}>
                            {' '}
                            <DateRangeIcon />
                            <ReduxFormField
                              fullWidth
                              name='availableFromDate'
                              validate={[lessThanAvailableUntil]}
                              component={ReduxDatePicker}
                              disabled={isDisabled}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          className={classes.containerItem}
                        >
                          <Typography variant='body1' align='left' gutterBottom>
                            {t('apartment.buildYear')}
                          </Typography>
                          <Field
                            name='buildYear'
                            normalize={onlyNums}
                            type='number'
                            inputProps={{ min: 0, max: 2050 }}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={[required, validateYear]}
                            required
                            disabled={isDisabled}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          sm={3}
                          xs={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.floor')}
                          </Typography>
                          <ReduxFormField
                            name='floor'
                            type='number'
                            //normalize={onlyNums}
                            inputProps={{ step: 1 }}
                            validate={[lessOrEqualThanFloors, isNumericOrEmpty]}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          sm={3}
                          xs={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('apartment.floors')}
                          </Typography>
                          <ReduxFormField
                            name='floors'
                            type='number'
                            //normalize={onlyNums}
                            inputProps={{ min: 0, step: 1 }}
                            validate={[moreOrEqualThanFloor, isNumericOrEmpty]}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' align='left' gutterBottom>
                            {t('apartment.squareMeters')}
                          </Typography>
                          <Field
                            name='squareMeters'
                            normalize={onlyNumsAndDecimals}
                            type='number'
                            validate={[required]}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            disabled={isDisabled}
                            InputIcon='m²'
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' align='left' gutterBottom>
                            {t('apartment.rentPrice')}
                          </Typography>
                          <Field
                            name='price'
                            normalize={onlyNumsAndDecimals}
                            type='number'
                            validate={[required]}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            disabled={isDisabled}
                            InputProps={{
                              min: 0,
                              step: 0.1,
                              endAdornment: 'm²'
                            }}
                            InputIcon='€'
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <RentRecommendation />
                        </Grid>
                        {/* <Grid item xs={12}>
                          <AdditionalInfoFields
                            t={t}
                            currentStep={currentStep}
                            classes={classes}
                            isDisabled={isDisabled}
                          />
                        </Grid> */}
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <Grid item xs={4}>
                        <BackButton
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>

                      <Grid item xs={8}>
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          toValidate={{
                            squareMeters: propertyInfoValues.squareMeters,
                            price: propertyInfoValues.price,
                            buildYear: buildingInfo.buildYear
                          }}
                          const toCheck={{
                            buildYear: validateYear(`${buildingInfo.buildYear}`),
                            floorNotExceedingFloors: lessOrEqualThanFloors(`${addressInfoValues.floor}`, addressInfoValues),
                            floorIsNumeric: isNumericOrEmpty(`${addressInfoValues.floor}`),
                            floorsNotBelowFloor: moreOrEqualThanFloor(`${addressInfoValues.floors}`, addressInfoValues),
                            floorsIsNumeric: isNumericOrEmpty(`${addressInfoValues.floors}`)
                          }
                          }
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest
                        fullWidth
                        content={t('apartment.hints.step5Hint')}
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 5 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid
                      className={classes.largeForm}
                      justify='space-between'
                      container
                    >
                      <Grid container spacing={1}>
                        <Grid item sm={12}>
                          <Typography variant='h5' gutterBottom>
                            {t('apartment.steps.step6heading')}
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          className={classes.containerItem}
                          xs={12}
                          sm={8}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.streetAddress')}
                          </Typography>
                          <Field
                            fullWidth
                            //normalize={charsSpace}
                            name='autocompleteLocation'
                            selectLabel={t('autocomplete.select')}
                            existingLocations={[]}
                            placeholder={t('autocomplete.placeholder')}
                            changeFormValue={changeFormValue}
                            streetNumberFormValue={addressInfoValues.streetNumber}
                            component={ReduxGoogleAutocomplete}
                            validate={[requiredLocation]}
                            required
                            isFromApartmentForm={true}
                            normalize={(val: string) => (typeof val === 'string' ? val.replace(/^\s+/, '') : val)}
                          />
                          {/* 
                          <ReduxFormField
                            name='autocompleteLocation'
                            selectLabel={t('autocomplete.select')}
                            normalize={charsSpace}
                            changeFormValue={changeFormValue}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            validate={[requiredLocation]}
                            required
                          /> */}
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={4}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.streetNumber')}
                          </Typography>
                          <ReduxFormField
                            name='streetNumber'
                            normalize={onlyNums}
                            defaultValue=''
                            min={0}
                            validate={[required, isStreetNumber]}
                            disabled={isDisabled}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.buildingLetterAndApartmentNumber')}
                          </Typography>
                          <ReduxFormField
                            name='buildingLetter'
                            defaultValue=''
                            validate={[isInvalidCharacters]}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        {/* <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={3}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.apartment')}
                          </Typography>
                          <ReduxFormField
                            name='apartmentNumber'
                            normalize={onlyNums}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid> */}
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.postalCode')}
                          </Typography>
                          <ReduxFormField
                            name='postalCode'
                            //set default value to prevent react error: A component is changing an uncontrolled input to be controlled.
                            defaultValue=''
                            normalize={onlyNums}
                            min={0}
                            validate={[required, isPostalCode]}
                            disabled={isDisabled}
                            required
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.postalArea')}
                          </Typography>
                          <ReduxFormField
                            name='postalArea'
                            validate={[validatePostalArea]}
                            disabled={isDisabled}
                            options={arrayOfCities}
                            component={ReduxFormSelect}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                            required
                          />
                          {/* {arrayOfCities.map((value) => (
                            <MenuItem key={value} value={value}>
                              {t(value)}
                            </MenuItem>
                          ))}
                          </ReduxFormField> */}
                        </Grid>
                        <Grid
                          item
                          className={classes.containerItem}
                          xs={6}
                          sm={6}
                        >
                          <Typography variant='body1' gutterBottom>
                            {t('person.district')}
                          </Typography>
                          <ReduxFormField
                            name='district'
                            defaultValue=''
                            normalize={charsSpace}
                            validate={[required]}
                            disabled={isDisabled}
                            component={MyInput}
                            style={{
                              width: '100%',
                              height: '58px',
                              padding: '20px',
                              background: '#E7ECEF'
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                    <Grid container>
                      <ErrorMessage error={error} />
                      <Grid container className={classes.buttonContainer}>
                        <Grid item xs={4}>
                          <BackButton
                            currentStep={currentStep}
                            doStepBack={doStepBack}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <NextStepButton
                            type='button'
                            beforeLogin={beforeLogin}
                            toValidate={{
                              autocompleteLocation:
                                addressInfoValues.autocompleteLocation,
                              postalArea: addressInfoValues.postalArea,
                              postalCode: addressInfoValues.postalCode,
                              streetNumber: addressInfoValues.streetNumber
                            }}
                            toCheck={{
                              streetNumber: isStreetNumber(
                                `${addressInfoValues.streetNumber}`
                              ),
                              buildingLetter: isInvalidCharacters(
                                `${addressInfoValues.buildingLetter}`
                              ),
                              postalCode: isPostalCode(
                                `${addressInfoValues.postalCode}`
                              )
                            }}
                            setIsEmpty={setIsEmpty}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      {' '}
                      <Suggest
                        fullWidth
                        content={t('apartment.hints.step6Hint')}
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            {currentStep === 7 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step7heading')}
                        </Typography>
                      </Grid>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <AdditionalInfoFields
                            t={t}
                            currentStep={currentStep}
                            classes={classes}
                            isDisabled={isDisabled || isLoading}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    {showAiImprovement && (
                      <Grid item xs={12} style={{ marginBottom: '20px' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={aiImprovement}
                              onChange={() => setAiImprovement(!aiImprovement)}
                              color="primary"
                            />
                          }
                          label={t('apartment.improveNotesWithAI')}
                        />
                      </Grid>
                    )}

                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}

                    <Grid container className={classes.buttonContainer}>

                      <Grid item xs={4}>
                        <BackButton
                          disabled={isLoading}
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>

                      <Grid item xs={8}>
                        {/* <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          disabled={isDisabled || isLoading}  // Disable button when loading or if isDisabled is true
                          type="button"
                          onClick={handleNextStep}
                          style={{ marginTop: 0 }}
                        >
                          {isLoading ? <CircularProgress size={24} /> : t('apartment.actions.nextStep')}
                        </Button> */}
                        <NextStepButton
                          type='button'
                          beforeLogin={beforeLogin}
                          toValidate={{
                            notes: notes
                          }}
                          toCheck={{
                            notes: isInvalidCharacters(notes)
                          }}
                          setIsEmpty={setIsEmpty}
                        />
                      </Grid>

                    </Grid>
                  </Grid>

                  <Grid item lg={6} md={12} sm={12} xs={12}>
                  <div className={classes.infoBoxWrapper}>
                    <Suggest
                      fullWidth
                      content={t('apartment.hints.step7Hint')}
                    />
                  </div>
                </Grid>
                </Grid>
              </>


            )}
            {currentStep === 8 && (
              <>
                <Grid container>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <Grid className={classes.largeForm} container>
                      <Grid item xs={12}>
                        <Typography variant='h5' gutterBottom>
                          {t('apartment.steps.step8heading')}
                        </Typography>
                      </Grid>{' '}
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Grid container className={classes.containerItem}>
                            <Grid item xs={12} sm={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('apartment.list.information.pastRenovations')}
                              </Typography>
                              <ReduxFormField
                                name='damages'
                                multiline={true}
                                component={MyTextArea}
                                validate={[isInvalidCharacters]}
                                style={{
                                  width: '100%',
                                  height: '105px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                                required
                              />
                            </Grid>
                          </Grid>
                          <Grid container className={classes.containerItem}>
                            <Grid item xs={12} sm={12}>
                              <Typography variant='body1' gutterBottom>
                                {t('apartment.list.information.futureRenovations')}
                              </Typography>
                              <ReduxFormField
                                name='renovations'
                                multiline={true}
                                disabled={isDisabled}
                                component={MyTextArea}
                                validate={[isInvalidCharacters]}
                                style={{
                                  width: '100%',
                                  height: '105px',
                                  padding: '20px',
                                  background: '#E7ECEF'
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            className={classes.containerItem}
                            xs={12}
                            sm={12}
                          >
                            <Typography variant='body1' gutterBottom>
                              {t('apartment.list.information.energyCertification')}
                            </Typography>
                            <ReduxFormField
                              name='energyCertification'
                              required
                              validate={[required]}
                              options={energyCertifications}
                              disabled={isDisabled}
                              component={ReduxFormSelect}
                              style={{
                                width: '100%',
                                height: '58px',
                                padding: '20px',
                                background: '#E7ECEF'
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    {isEmpty && (
                      <Typography style={{ color: 'red' }} variant='body1'>
                        {t('apartment.actions.stepFail')}
                      </Typography>
                    )}
                    <Grid container className={classes.buttonContainer}>
                      <Grid item xs={4}>
                        <BackButton
                          disabled={isLoading}
                          currentStep={currentStep}
                          doStepBack={doStepBack}
                        />
                      </Grid>

                      <Grid item xs={8}>
                        {/* Conditionally render the appropriate button based on aiImprovement */}
                        {aiImprovement ? (
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            disabled={isDisabled || isLoading}  // Disable button when loading or if isDisabled is true
                            type="button"
                            onClick={handleNextStep}
                            style={{ marginTop: 0 }}
                          >
                            {isLoading ? <CircularProgress size={24} /> : t('apartment.actions.nextStep')}
                          </Button>
                        ) : (
                          <SubmitButton
                            setIsEmpty={setIsEmpty}
                            toCheck={{
                              damages: isInvalidCharacters(damages),
                              renovations: isInvalidCharacters(renovations)
                            }}
                            t={t}
                            submit={true}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} md={12} sm={12} xs={12}>
                    <div className={classes.infoBoxWrapper}>
                      <Suggest
                        fullWidth
                        content={t('apartment.hints.step8Hint')}
                      />
                    </div>
                  </Grid>
                </Grid>
              </>
            )}

          </Grid>
        </Grid>
      </form>
    )
  }
}

const selector = formValueSelector('ApartmentInformationForm')

const mapStateToProps = (state: StateInterface) => ({
  // address information
  autocompleteLocation: selector(state, 'autocompleteLocation'),
  postalArea: selector(state, 'postalArea'),
  postalCode: selector(state, 'postalCode'),
  streetNumber: selector(state, 'streetNumber'),
  district: selector(state, 'district'),
  //apartmentNumber: selector(state, 'apartmentNumber'),
  buildingLetter: selector(state, 'buildingLetter'),
  // size information
  rooms: selector(state, 'rooms'),
  kitchen: selector(state, 'kitchen'),
  storage: selector(state, 'storage'),
  balcony: selector(state, 'balcony'),
  condition: selector(state, 'condition'),
  price: selector(state, 'price'),
  // building information
  squareMeters: selector(state, 'squareMeters'),
  buildYear: selector(state, 'buildYear'),
  floor: selector(state, 'floor'),
  floors: selector(state, 'floors'),
  availableFromDate: selector(state, 'availableFromDate'),
  buildingType: selector(state, 'buildingType'),
  // additional properties
  waterFeeBasis: selector(state, 'waterFeeBasis'),
  waterFee: selector(state, 'waterFee'),
  heating: selector(state, 'heating'),
  sauna: selector(state, 'sauna'),
  parking: selector(state, 'parking'),
  petsAllowed: selector(state, 'petsAllowed'),
  dishwasher: selector(state, 'dishwasher'),
  laundryMachine: selector(state, 'laundryMachine'),
  notes: selector(state, 'notes'),
  damages: selector(state, 'damages'),
  renovations: selector(state, 'renovations'),
  energyCertification: selector(state, 'energyCertification'),
  internetIncluded: selector(state, 'internetIncluded'),
  // newly added properties
  renovatedCheckBoxProperty: selector(state, 'renovatedCheckBoxProperty'),
  hasElevator: selector(state, 'hasElevator'),
  isFurnished: selector(state, 'isFurnished'),
  hasBuiltInClosetCheckBoxProperty: selector(state, 'hasBuiltInClosetCheckBoxProperty'),
  hasSaunaCheckBoxProperty: selector(state, 'hasSaunaCheckBoxProperty'),
  petsAllowedCheckBoxProperty: selector(state, 'petsAllowedCheckBoxProperty'),
  housingPropertySauna: selector(state, 'housingPropertySauna'),
  newProperty: selector(state, 'newProperty'),
});


const mapDispatchToProps = (dispatch: Dispatch) => ({
  changeFormValue: (field: string, value: string) =>
    dispatch(change('ApartmentInformationForm', field, value)),
  doNextStep: (beforeLogin: boolean) => dispatch(stepForward({ beforeLogin }))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'ApartmentInformationForm',
    initialValues: {
      laundryMachine: 'room'
    }
  })(withTranslation()(ApartmentInformationForm as any) as any) as any
) as any
